import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const Background = styled.div<{ hasLogo?: boolean }>`
  ${borderRadius.r05};
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  overflow: hidden;
  ${({ hasLogo }) =>
    !hasLogo &&
    css`
      color: var(--text-default);
      background-color: var(--surface-default);
    `}
`;

export const Fallback = styled.div`
  ${typographyV2.titleLg};
  text-transform: capitalize;
`;

export const Img = styled.img`
  width: inherit;
  height: inherit;
  object-fit: contain;
`;
